
  export const exporDatatHeaders = [
    {
      label: "Member ID",
      key: "loyalty_id",
    },
    {
      label: "Shipto",
      key: "customer_account_number",
    },
    {
      label: "Billto",
      key: "customer_billto_account_number",
    },
    {
      label: "Shipto Name",
      key: "Customer_Account_customer_name",
    },
    {
      label: "Startup Status",
      key: "startup_flag",
    },
    
    {
      label: "Startup Start Date",
      key: "startup_start_date",
    },

    {
      label: "Startup End Date",
      key: "startup_end_date",
    },
    {
      label: "Multiplier Status",
      key: "multiplier",
    },
  
    
  ];
  
  